import React from "react";
import { useParams } from "react-router-dom";

import AddPayment from "./AddPayment";
import PaymentDetails from "./PaymentDetails";

const PaymentView = () => <PaymentDetails />;

/** /billing/payments/:id/edit = the New payment form, pre-filled (PAY-018). */
export const EditPaymentPage = () => {
  const { id } = useParams<{ id: string }>();
  return <AddPayment key={id} editPaymentId={id || ""} />;
};

export default PaymentView;
